module.exports = __webpack_public_path__ + "img/confetti.586e9f7c.svg";